import type { OpenAPI } from "simplydo/interfaces";

/** A business profile as GET /users/profiles/{id} returns it. */
export type IdeaBusinessProfile =
  OpenAPI.GET<"/users/profiles/{business_profile_id}">["response"]["ideaBusinessProfile"];

/** A loaded profile, or the copy locked on an idea, which may lack `createdAt`. */
export type IdeaBusinessProfileOverview = Omit<
  IdeaBusinessProfile,
  "createdAt"
>;

/** A business profile as embedded elsewhere; the modal loads the full profile itself. */
export type IdeaBusinessProfileRef = Pick<IdeaBusinessProfile, "_id"> &
  Partial<Pick<IdeaBusinessProfile, "name" | "image" | "imageUrl">>;

/** A business profile as stored, which updates return. */
export type StoredIdeaBusinessProfile = OpenAPI.Schemas["IdeaBusinessProfile"];

export type IdeaBusinessProfileContact = NonNullable<
  IdeaBusinessProfile["contacts"]
>[number];

export type IdeaBusinessProfileAddress = NonNullable<
  IdeaBusinessProfile["addresses"]
>[number];

export type IdeaBusinessProfileUpdate = Partial<
  OpenAPI.POST<"/users/profiles/{business_profile_id}">["requestBody"]
>;

export type IdeaBusinessProfileUpdateResponse =
  OpenAPI.POST<"/users/profiles/{business_profile_id}">["response"];

export type IdeaBusinessProfileDeleteResponse =
  OpenAPI.DELETE<"/users/profiles/{business_profile_id}">["response"];

export type EditableContact = {
  id: string;
  fullName: string;
  email: string;
  phoneNumber: string;
  jobTitle: string;
};

export type EditableAddress = {
  id: string;
  streetAddress: string;
  city: string;
  postcode: string;
  country: string;
  region: string;
};

export type BusinessProfileRoleUser = NonNullable<
  OpenAPI.GET<"/roles/{for_type}/{for_id}/users">["response"]["users"]
>[number];

export type CompaniesHouseCompany = {
  company_name?: string;
  links?: { self?: string };
};

export const toEditableContact = (
  contact: IdeaBusinessProfileContact,
): EditableContact => ({
  id: contact.id ?? "",
  fullName: contact.fullName ?? "",
  email: contact.email ?? "",
  phoneNumber: contact.phoneNumber ?? "",
  jobTitle: contact.jobTitle ?? "",
});

export const toEditableAddress = (
  address: IdeaBusinessProfileAddress,
): EditableAddress => ({
  id: address.id ?? "",
  streetAddress: address.streetAddress ?? "",
  city: address.city ?? "",
  postcode: address.postcode ?? "",
  country: address.country ?? "",
  region: address.region ?? "",
});
